/**
 * Licensed Materials - Property of Home Depot Mexico.
 */

import { ID } from '@/data/types/Basic';
import { WidgetData } from '@/data/types/Preview';
import { Widget } from '@/data/types/Slot';
import { isEqual } from 'lodash';
import { FC, PropsWithChildren, createContext, useCallback, useContext, useState } from 'react';

type Props = PropsWithChildren<{
	widget: Widget & {
		// the ID that using to retrieve widget data.
		dataId: ID;
	};
}>;

type PreviewWidgetContextValue = {
	setESpotData?: (eSpot: WidgetData['marketingSpotData']) => void;
};

const PreviewWidgetContext = createContext<PreviewWidgetContextValue>({});
const PreviewWidgetProvider = PreviewWidgetContext.Provider;
export const usePreviewWidget = () => useContext(PreviewWidgetContext);
/**
 * Widget Wrapper removing preview condition to render the same content as current site.
 */
export const PreviewWidgetFrame: FC<Props> = ({ widget, children }) => {
	const [marketingSpotData, setMarketingSpotData] = useState<WidgetData['marketingSpotData']>();

	const setESpotData = useCallback((eSpot: WidgetData['marketingSpotData']) => {
		setMarketingSpotData((pre) => (isEqual(pre, eSpot) ? pre : eSpot));
	}, []);

	return <PreviewWidgetProvider value={{ setESpotData }}>{children}</PreviewWidgetProvider>;
};
